import { render, staticRenderFns } from "./PermissionFormView.vue?vue&type=template&id=e2bd7d62&scoped=true&"
import script from "./PermissionFormView.vue?vue&type=script&lang=js&"
export * from "./PermissionFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bd7d62",
  null
  
)

export default component.exports